export default "__VITE_ASSET__CHUW$QZg__"